// extracted by mini-css-extract-plugin
module.exports = {"container":"NextAndBackButton_container__15pij"};